// extracted by mini-css-extract-plugin
export default {"vehiclesContainer":"VehicleFilter_vehiclesContainer__usM9t"};